import { PDFFormType } from '@models/matter-form-data';

export class SetField {
	static readonly type = '[matter-form-data] set field';
	// rome-ignore lint/suspicious/noExplicitAny: <explanation>
	constructor(
		public payload: {
			id: string;
			type: PDFFormType;
			name: string;
			url: string;
			field: string;
			value: any;
		},
	) {}
}
